import { btn } from "../Button/buttonStyles";
/**
 * Shared form card used by every System Value editor (Services, Specialization,
 * Units, Currency, Language Pairs, ...). Provides the consistent heading +
 * container + mandatory-fields footer + left-aligned action buttons. The caller
 * supplies the actual form fields (FormInput, FormSelect, etc.) as children
 * and an `error` banner string for any cross-field validation message.
 *
 * @param {string} title e.g. "Edit Service"
 * @param {(e)=>void} onSubmit form submit handler
 * @param {()=>void} onCancel cancel handler
 * @param {React.ReactNode} children field components
 * @param {string} [error] inline error banner above the footer
 * @param {boolean} [submitting=false] disables buttons + shows submitting label
 * @param {string} [submitLabel="Save"]
 * @param {string} [cancelLabel="Cancel"]
 */
const SystemValueForm = ({
  title,
  onSubmit,
  onCancel,
  children,
  error,
  submitting = false,
  submitLabel = "Save",
  cancelLabel = "Cancel",
}) => {
  return (
    <div>
      <div className="mb-5">
        <h2 className="text-xl font-bold text-gray-900">{title}</h2>
      </div>
      <form
        onSubmit={onSubmit}
        noValidate
        className="bg-white shadow-sm border border-gray-100 rounded-lg p-5 space-y-5"
      >
        {children}

        {error && (
          <div className="bg-danger-50 border border-danger-200 text-danger-700 text-sm px-3 py-2 rounded">
            {error}
          </div>
        )}

        <div className="pt-3 border-t border-gray-100 space-y-3">
          <span className="block text-xs text-gray-500">
            Fields marked with <span className="text-danger-500">*</span> are mandatory.
          </span>
          <div className="flex gap-2 text-sm">
            <button
              type="submit"
              disabled={submitting}
              className={btn("primary", "sm")}
            >
              {submitting ? "Saving..." : submitLabel}
            </button>
            <button
              type="button"
              onClick={onCancel}
              disabled={submitting}
              className={btn("secondary", "sm")}
            >
              {cancelLabel}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default SystemValueForm;
